/** What Write's "no sources" card counts (apiserver readCoverage, Round 36). */
export interface NoSources {
  read: number | null;
  unreadRecent: number;
  unreadOlder: number;
}

/**
 * "12 older articles and 3 from the last 7 days are still waiting to be
 * read." (Round 36); null when none are.
 */
export function waitingLine({ unreadRecent: recent, unreadOlder: older }: NoSources) {
  if (!recent && !older) return null;
  const n = (k: number) => k.toLocaleString('en-US');
  const what =
    older && recent
      ? `${n(older)} older ${older === 1 ? 'article' : 'articles'} and ${n(recent)} from the last 7 days are`
      : older
        ? `${n(older)} older ${older === 1 ? 'article is' : 'articles are'}`
        : `${n(recent)} ${recent === 1 ? 'article' : 'articles'} from the last 7 days ${recent === 1 ? 'is' : 'are'}`;
  return `${what} still waiting to be read. Prism AI reads new articles within a few hours of publishing.`;
}
